// reducer
// import Vue from "vue";

export const resetPagination = state => {
  // Vue.set(state.MyClients, "myClients", data);
  state.utilities.pagination = {
    currentPage: 0,
    perPage: 2
  };
  // state.MyClients.myClients = {
  //   ...state.MyClients.myClients,
  //   ...data
  // };
};

export const progressPagination = state => {
  state.utilities.pagination.currentPage += 1;
};
